// Texto del código tal como lo guarda el lambda: mayúsculas y sin espacios.

function codeFromUrl(text: string): string | null {
    try {
        return new URL(text).searchParams.get('code');
    } catch {
        return null;
    }
}

/** Normaliza lo tecleado o lo leído por QR (texto plano o URL con `?code=`). */
export function normalizeDiscountCode(raw: string): string {
    const trimmed = raw.trim();
    const text = /^https?:\/\//i.test(trimmed) ? (codeFromUrl(trimmed) ?? '') : trimmed;
    return text.replace(/\s+/g, '').toUpperCase();
}
